<template>
  <div>
    <div
      id="jobs-banner-img"
      class="
        banner
        d-flex
        flex-column
        justify-content-center
        align-items-center
        text-center
      "
      style=" background-color: rgb(16, 65, 165);
        background-image: url('https://manatal-backend-public-assets.s3.amazonaws.com/media/career_portal_image_direct_upload/649dae71-54ba-44ca-9689-84a3f34e1007_ccilickcareer1.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        min-height: 720px;"
    >
      <h1 class="mt-5">C.S.I. GROUP</h1>
      <p class="mt-1"></p>

      <router-link :to="{ name: 'home' }">
        <button
          type="button"
          class="btn btn-lg btn-outline-light mt-4"
          style="background-color: white; color: rgb(16, 65, 165)"
          @click="viewOpening" >
          View Opening
        </button>
      </router-link>

      <!-- <a href="https://www.careers-page.com/cclick?page=1#openings"
        ><button
          type="button"
          class="btn btn-lg btn-outline-light mt-4"
          style="background-color: white; color: rgb(16, 65, 165)"
        >
          View Opening
        </button></a
      > -->
    </div>

    <div>
      <div class="gallery container mt-5 pt-1 pb-4">
        <div class="row px-5"></div>
      </div>
      <div class="container mb-5 px-xl-5">
        <p><br /></p>
      </div>
      <hr id="openings" class="mt-5 mx-5" />
      <div class="mt-5 text-center">
        <h1 id="scroll">Our Openings</h1>
        <h4 class="positions">{{ getJobCount }} Open Positions</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["jobcount"],
  methods:{
    viewOpening(){

      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      })
    }

  },
  computed: {
    getJobCount() {
      //console.log(JSON.stringify(this.jobcount))
      return this.jobcount;
    },
  },
};
</script>

<style scoped>
.banner {
  min-height: 56vh;
  padding-bottom: 20px;
  background: #546cb4;
  color: white;
  text-align: center;
  text-shadow: 1px 2px 3px rgb(0 0 0 / 50%);
}
.h1,
h1 {
  font-size: 2.5rem;
}
.positions {
  font-size: 16px;
  color: #808080;
}
</style>